import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FiAlertTriangle } from 'react-icons/fi'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import styled from 'styled-components'

import { StyledActionButton } from '@/components/common/Buttons.tsx'

const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.common.error};
  display: flex;
  height: 70px;
  justify-content: center;
  width: 100%;
`

const MessageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  gap: 16px;
  justify-content: center;
`

const AlertIcon = styled(FiAlertTriangle)`
  color: ${(props) => props.theme.colors.destructive.main};
`

const CloseIcon = styled(IoIosCloseCircleOutline)`
  cursor: pointer;
  flex-grow: 0;
  margin-right: 8px;
`

type ConnectionBannerProps = {
  onRetry: () => void
}

// Surfaces socket (chat) unreachability without blocking the rest of the app;
// see SocketContext's SOCKET_CONNECTION_TIMEOUT_MS for when this appears.
export const ConnectionBanner = ({ onRetry }: ConnectionBannerProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'connectionBanner',
  })
  const [isDismissed, setIsDismissed] = useState(false)

  if (isDismissed) return null

  return (
    <Container role="status">
      <MessageContainer>
        <AlertIcon />
        {t('message')}
        <StyledActionButton onClick={onRetry} size="small" variant="Secondary">
          {t('retry')}
        </StyledActionButton>
      </MessageContainer>
      <CloseIcon
        aria-label={t('dismiss')}
        onClick={() => setIsDismissed(true)}
        role="button"
        size={24}
      />
    </Container>
  )
}
